import { render } from "./LoginPageAdmin.vue?vue&type=template&id=c80ee544&scoped=true"
import script from "./LoginPageAdmin.vue?vue&type=script&lang=js"
export * from "./LoginPageAdmin.vue?vue&type=script&lang=js"

import "./LoginPageAdmin.vue?vue&type=style&index=0&id=c80ee544&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80ee544"]])

export default __exports__